import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65eb2993"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Acordeao__Cabecalho" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-file Acordeao__Icone" }, null, -1))
const _hoisted_3 = { class: "Acordeao__Titulo" }

import Accordion from "primevue/accordion"
  import AccordionTab from "primevue/accordiontab"

  interface Props {
    titulo: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MAcordeaoImportadores',
  props: {
    titulo: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Accordion), {
    "active-index": [0],
    class: "Acordeoes"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AccordionTab), null, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.titulo), 1)
          ])
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})